import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { TradingViewWidget } from './TradingViewWidget';
const POINTS = [{
  number: '01',
  title: 'Interfaz moderna',
  description: 'Un entorno limpio para consultar mercados y ordenar tu actividad de trading.'
}, {
  number: '02',
  title: 'Acceso digital',
  description: 'El registro y el acceso a la plataforma se realizan de forma online.'
}, {
  number: '03',
  title: 'Experiencia multi-mercado',
  description: 'Distintas categorías de instrumentos dentro de una misma experiencia.'
}];
const OVERVIEW_CONFIG = {
  colorTheme: 'light',
  dateRange: '12M',
  locale: 'es',
  largeChartUrl: '',
  isTransparent: true,
  showFloatingTooltip: true,
  width: '100%',
  height: '100%',
  showSymbolLogo: true,
  tabs: [{
    title: 'Forex',
    symbols: [{
      s: 'FX:EURUSD',
      d: 'EUR/USD'
    }, {
      s: 'FX:GBPUSD',
      d: 'GBP/USD'
    }, {
      s: 'FX:USDJPY',
      d: 'USD/JPY'
    }]
  }, {
    title: 'Metales',
    symbols: [{
      s: 'OANDA:XAUUSD',
      d: 'Oro'
    }, {
      s: 'OANDA:XAGUSD',
      d: 'Plata'
    }]
  }, {
    title: 'Índices',
    symbols: [{
      s: 'OANDA:NAS100USD',
      d: 'US 100'
    }, {
      s: 'OANDA:SPX500USD',
      d: 'US 500'
    }]
  }, {
    title: 'Cripto',
    symbols: [{
      s: 'BITSTAMP:BTCUSD',
      d: 'BTC/USD'
    }, {
      s: 'BITSTAMP:ETHUSD',
      d: 'ETH/USD'
    }]
  }]
};
export function Platform() {
  return <section id="plataforma" className="border-y border-line bg-white py-16 sm:py-24" data-id="element-157" data-mp="3bok7wgpfqmg8">
      <div className="mx-auto grid max-w-[1240px] items-center gap-10 px-4 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14 lg:px-8" data-id="element-158" data-mp="3pns6p8horsjw">
        <div data-id="element-159" data-mp="14vzwrx0z3nfm">
          <Reveal data-id="element-160" data-mp="14vq8cdvktoc1">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-161" data-mp="14uykjp880uwb">
              Plataforma
            </p>
            <h2 className="mt-4 text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink-900 sm:text-[2.5rem]" data-id="element-162" data-mp="10u4t4lvkkxyo">
              Todo lo que necesitas. En una experiencia.
            </h2>
            <p className="mt-5 text-[15.5px] leading-relaxed text-ink-500" data-id="element-163" data-mp="2gqzzxpkrt05">
              Una interfaz moderna para consultar mercados y gestionar tu actividad
              de trading.
            </p>
          </Reveal>

          <ul className="mt-9 space-y-px" data-id="element-164" data-mp="bgxglsgkl93j">
            {POINTS.map((point, i) => <Reveal key={point.number} delay={i * 0.06} data-id="element-165" data-mp="3awaoykj7qp9e" data-mpi={i}>
                <li className="flex gap-5 border-t border-line py-6" data-id="element-166" data-mp="3fyjhxgw35rbi">
                  <span className="text-[13px] font-semibold tracking-[0.08em] text-brand-400" data-id="element-167" data-mp="3jzbpm5pb7o5o">
                    {point.number}
                  </span>
                  <div data-id="element-168" data-mp="3or3abzlsaznw">
                    <h3 className="text-[16px] font-semibold text-ink-900" data-id="element-169" data-mp="2s7vxjw4zh982">
                      {point.title}
                    </h3>
                    <p className="mt-2 text-[14.5px] leading-relaxed text-ink-500" data-id="element-170" data-mp="2w8ft4v9ws4s3">
                      {point.description}
                    </p>
                  </div>
                </li>
              </Reveal>)}
          </ul>

          <Reveal delay={0.1} data-id="element-171" data-mp="2josko9hs46h5">
            <CTAButton label="Conocer la plataforma" location="platform" size="md" className="mt-9 w-full sm:w-auto" data-id="element-172" data-mp="2fp1qrwwyha8e" />
          </Reveal>
        </div>

        <Reveal delay={0.08} data-id="element-173" data-mp="25rdv94rizyp6">
          <div className="overflow-hidden rounded-2xl border border-line bg-canvas p-1.5 shadow-card sm:p-3" data-id="element-174" data-mp="25sf3z2l2k93q">
            <div className="h-[440px] overflow-hidden rounded-xl bg-white sm:h-[480px]" data-id="element-175" data-mp="20yav2ds8tr00">
              <TradingViewWidget kind="market-overview" config={OVERVIEW_CONFIG} data-id="element-176" data-mp="1w1ki3zbqjbit" />
            </div>
          </div>
          <p className="mt-3 text-center text-[11.5px] text-ink-400" data-id="element-177" data-mp="1rxmkjt2268rv">
            Datos de mercado proporcionados por TradingView. Solo con fines
            informativos.
          </p>
        </Reveal>
      </div>
    </section>;
}